import { Col, Row } from 'antd';
import MarketItem from 'components/MarketItem/MarketItem';
import { IAddedProduct, IAddingProduct } from 'containers/ProductDetailsPage';
import { RelatedProduct } from 'containers/ProductDetailsPage/types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Product, TrackingAddToCartAddFromType, TrackingProductImpressionType } from 'types/schema';
import media from 'utils/mediaStyle';
import utilMessages from 'utils/messages';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';

const RelatedProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${media.lg`
      margin-top: 40px;
  `}
`;
const RelatedProductsTitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #343538;

  ${media.lg`
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  `}
`;

interface RelatedProductDetailsProps {
  productId?: string;
  relatedProducts?: RelatedProduct[];
  loggedIn: boolean;
  gotoSignIn: () => void;
  addedRelatedProducts: IAddedProduct;
  addingRelatedProducts: IAddingProduct;
  permissions: string[];
  onToggleFavorite: (data: { product: Product }) => void;
  onOpenNote: (product: Product) => void;
  onDeleteNote: (product: Product) => void;
}
const RelatedProductDetails = (props: RelatedProductDetailsProps) => {
  const {
    productId,
    relatedProducts,
    loggedIn,
    gotoSignIn,
    addedRelatedProducts,
    addingRelatedProducts,
    permissions,
    onToggleFavorite,
    onOpenNote,
    onDeleteNote,
  } = props;
  return !!relatedProducts?.length ? (
    <RelatedProductsContainer>
      <RelatedProductsTitle>
        <FormattedMessage {...utilMessages.similarProducts} />
      </RelatedProductsTitle>
      <Row
        gutter={[
          { xs: 8, md: 16, lg: 24 },
          {
            xs: 8,
            md: 16,
            lg: 24,
          },
        ]}
      >
        {relatedProducts?.map((product, index) => (
          <Col xs={12} md={6} lg={4} key={product.id}>
            <MarketItem
              vertialOnly
              listName="Section Product List"
              loggedIn={loggedIn}
              gotoSignIn={gotoSignIn}
              product={product}
              loading={product?.loading}
              maxQuantity={100}
              favorite={product.isFavorite}
              note={product.note}
              added={addedRelatedProducts[product.id]}
              adding={addingRelatedProducts[product.id]}
              position={index}
              permissions={permissions}
              onToggleFavorite={() => onToggleFavorite({ product: product })}
              onOpenNote={() => onOpenNote(product)}
              onDeleteNote={() => {
                onDeleteNote(product);
              }}
              impressionProperties={{ type: TrackingProductImpressionType.RelatedProduct }}
              addToCartProperties={{ addFrom: TrackingAddToCartAddFromType.RelatedProduct }}
              ga4Callback={({ id }) =>
                sendGA4Event(EventName.PDP_RECOMMENDATION_CLICK, {
                  from_product_id: productId,
                  to_product_id: id,
                  placement: 'related_product',
                  position: index + 1,
                })
              }
              isProductDetail={true}
            />
          </Col>
        ))}
      </Row>
    </RelatedProductsContainer>
  ) : null;
};

export default RelatedProductDetails;
